import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import { CatalogueDatasetDto } from "../dtos/Governance/catalogue-dataset-dto";

export const RecycleDatasetService = {
	async getDeletedDatasets(
		page = 0,
		size = 20,
		sort = "DESC",
		sortBy = "MODIFIED",
	): Promise<any> {
		const queryParams = new URLSearchParams({
			page: page.toString(),
			size: size.toString(),
			sort,
			sortBy,
		});
		const governanceUrl = API.governance.datasetsv2.replace("/v2/datasets", "");
		const res = await ItiHttpService.get(
			`${governanceUrl}v2/datasets/deleted?${queryParams}`,
		);
		return {
			content:
				res.content?.map((item: any) => new CatalogueDatasetDto(item)) || [],
			totalElements: res.totalElements || 0,
			totalPages: res.totalPages || 0,
			number: res.number || 0,
			size: res.size || size,
		};
	},

	async restoreDataset(datasetId: string): Promise<boolean> {
		try {
			await ItiHttpService.put(
				`${API.governance.datasetsv2}/${datasetId}/restore`,
				{},
			);
			return true;
		} catch (error) {
			return false;
		}
	},

	async permanentDeleteDataset(datasetId: string): Promise<boolean> {
		try {
			await ItiHttpService.delete(
				`${API.governance.datasetsv2}/${datasetId}?option=PHYSICAL`,
			);
			return true;
		} catch (error) {
			return false;
		}
	},
};
